import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ResearchProposalInformationModule from "../../Pages/Submitter/ResearchProposalInformationPage/ResearchProposalInformationModule";
import InfoAboutResearcher from "../../Pages/Submitter/ResearchProposalInformationPage/InformationAboutResearchersModule";
import OtherSupport from "../../Pages/Submitter/ResearchProposalInformationPage/OtherSupportingParties";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import $ from "jquery";
import {
  SetResearchProposalInformationValidate,
  UpdateResearchProposalInformation,
  ValidateResearchProposalInformation,
} from "../../Redux/Reducers/Submitter/ResearchProposalInformation";
import PopupAHSF from "../../Components/PopupAHSF";
import { useLocation, useNavigate } from "react-router-dom";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";

function ResearchProposalInformation() {
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;
      console.log(guid, "slkdslkddddlksdl");
      
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      ResearchProposalInformation:
        state.ResearchProposalInformation.ResearchProposalInformation,
      ResearchProposalInformationValidate:
        state.ResearchProposalInformation.ResearchProposalInformationValidate,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  const SaveDataPage = async (withValidate) => {
    const saved = await dispatch(
      UpdateResearchProposalInformation({
        ...state.ResearchProposalInformation,
      })
    );

    if (withValidate) {
      const validate = await dispatch(
        ValidateResearchProposalInformation(
          // state.ResearchProposalInformation.applicationInformationId
          localStorage.getItem("ApplicationInformationId")
        )
      );

      if (validate.payload?.length > 0) {
        setisPopupOpenStatus(true);

        // $(".WorkPlanEstimatedBudget").trigger("click");
        // navigate("/SRFund/WorkPlanEstimatedBudget");
      } else {
        $(".WorkPlanEstimatedBudget").trigger("click");
        navigate("/SRFund/WorkPlanEstimatedBudget");
      }
    }
  };
  const shouldDisableFields = !(
    ActiveRound ==ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.applicationStatusId=="57ca8392-5b8e-4625-8a37-00dfc27d5b28"?true: ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  console.log( ActiveRound , ApplicationInformation?.aI_RoundYearId ,
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit ,
    window.location.href.includes("manager") , "hhhhgfgfffffffff");
  
  useEffect(() => {
    dispatch(SetResearchProposalInformationValidate([]));
  }, []);
  return (
    <>
      <ResearchProposalInformationModule
      applicationInformationId={guid}
        shouldDisableFields={shouldDisableFields}
      />
        { ApplicationInformation?.aI_RoundYearId?<>
      <SharedDiv
        showTitle={true}
        titleName="معلومات الباحثين المشاركين في المشروع ان وجد"
        child={[
          <InfoAboutResearcher
            shouldDisableFields={shouldDisableFields}
            applicationInformationId={
              localStorage.getItem("ApplicationInformationId")||guid
              //   state.ApplicationInformation?.applicationInformationId
            }
          />,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="الجهات الداعمة الأخرى لمشروع البحث المقترح إن وجدت"
        child={[
          <OtherSupport
            shouldDisableFields={shouldDisableFields}
            applicationInformationId={
              //   state.ApplicationInformation?.applicationInformationId
              localStorage.getItem("ApplicationInformationId")||guid
            }
          />,
        ]}
      /></>:""}
      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true);
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة" // Arabic for "Please fill in the required fields"
        componentBody={state.ResearchProposalInformationValidate}
      />
    </>
  );
}

export default ResearchProposalInformation;
